module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp09-e3751702fa2484be86474e82d5839654.jpg";